<div class="small-only-text-center">
  <div
    class="panel rs-inline-block rs-wd-s6 rs-wd-m10 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
  ></div>
</div>
<div class="panel rs-bg-grey1 clearfix">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>

  <div class="rs-padding-top1 rs-padding-bottom1">
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
</div>
<div class="panel rs-bg-grey1 clearfix">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>

  <div class="rs-padding-top1 rs-padding-bottom1">
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
</div>
<div class="panel rs-bg-grey1 clearfix">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>

  <div class="rs-padding-top1">
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
  <div
    class="panel rs-bg-grey2 rs-no-margin-bottom rs-margin-left2-neg rs-margin-right2-neg rs-no-radius-top rs-padding-top1 rs-padding-bottom1"
  >
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
</div>
<div class="panel rs-bg-grey1 clearfix">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>

  <div class="rs-padding-top1">
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
  <div
    class="panel rs-bg-grey2 rs-no-margin-bottom rs-margin-left2-neg rs-margin-right2-neg rs-no-radius rs-padding-top1"
  >
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
  <div class="rs-padding-top1">
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
  <div
    class="panel rs-bg-grey2 rs-no-margin-bottom rs-margin-left2-neg rs-margin-right2-neg rs-no-radius rs-padding-top1"
  >
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
  <div class="rs-padding-top1">
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
  <div
    class="panel rs-bg-grey2 rs-no-margin-bottom rs-margin-left2-neg rs-margin-right2-neg rs-no-radius-top rs-padding-top1 rs-padding-bottom1"
  >
    <div class="rs-flex-row rs-flex-middle-medium">
      <div class="rs-flex-column">
        <div class="rs-padding-bottom1">
          <div
            class="panel rs-wd-s16 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
          ></div>
          <div
            class="panel rs-wd-s20 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
          ></div>
          <div
            class="panel rs-wd-s18 rs-wd-m58 rs-h-s2 rs-no-padding rs-no-margin-bottom rs-bg-grey4 rs-anim-loading"
          ></div>
        </div>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <div
          class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>
    </div>
  </div>
</div>
